import React, { useState } from 'react';
import { useEffectAsync } from '../../../../helpers';
import { getQuestionnaireTree } from '../../Services/questionnaire.service';
// @ts-ignore
import styles from './QuestionnairePreview.module.scss';
import QuestionnairePreviewItem from './QuestionnairePreviewItem';
import { QuestionnaireItemType } from '../../Enums/QuestionnaireItemType.enum';
import { QuestionnaireItemSubtype } from '../../Enums/QuestionnaireItemSubtype.enum';

interface Props {
	questionnaireId: string;
}

export interface QuestionnaireItemResultColoring {
	children: {
		textColor: string;
		backgroundColor: string;
		conditions: {
			equal: number | string;
			smallerOrEqual: number | string;
			biggerOrEqual: number | string;
		}[];
	}[];
}

export interface QuestionnaireItem {
	id: string;
	description?: string;
	key?: string;
	parentId?: string;
	position?: number;
	settings?: {
		resultColoring?: QuestionnaireItemResultColoring;
		placeholder?: string;
	};
	subtype?: QuestionnaireItemSubtype;
	type?: QuestionnaireItemType;
	title: string;
	title2?: string;
	value?: any;
	children?: QuestionnaireItem[];
}

const QuestionnairePreview: React.FC<Props> = ({ questionnaireId }) => {
	const [questionnaireStructure, setQuestionnaireStructure] = useState<
		QuestionnaireItem[] | undefined
	>(undefined);

	useEffectAsync(async () => {
		setQuestionnaireStructure(
			(await getQuestionnaireTree(questionnaireId)).data,
		);
	}, [questionnaireId]);

	console.log('questionnaireStructure', questionnaireStructure);

	return (
		<div className={styles.wrapper}>
			{questionnaireStructure?.map(item => (
				<React.Fragment key={item.id}>
					<QuestionnairePreviewItem item={item} />
				</React.Fragment>
			))}
		</div>
	);
};

export default QuestionnairePreview;
